import React, { useState, useEffect, useContext } from 'react'
import { useNode, useEditor } from '@craftjs/core'
import { ROOT_NODE } from '@craftjs/utils'

import { CreateCustomBlock } from './CreateCustomBlock'
import { CreateGlobalCustomBlock } from './CreateGlobalCustomBlock'

import { ToolbarSection } from '../Toolbar/ToolbarSection'
import { ToolbarItem } from '../Toolbar/ToolbarItem'

import { GlobalCustomBlocksContext } from '../../../../services/globalCustomBlocksContext'

import {
  isDisabled,
  getGlobalParent,
  getGlobalId,
  serializeNodeTree,
  getAncestors,
} from '../../../../utils/node'

export const AdvancedSettings = () => {
  const { selected, query } = useEditor((state) => ({
    selected: state.events.selected,
  }))

  const isGlobal = getGlobalId(selected, query) !== null

  const { globalCustomBlocks, updateGlobalCustomBlock } = useContext(GlobalCustomBlocksContext)

  const onSaveGlobalCustomBlock = (nodeId) => {
    const globalParentId = getGlobalParent(nodeId, query)

    const nodes = query.node(globalParentId).toNodeTree()
    const serializedNodes = serializeNodeTree(nodes, query)
    const json_content = JSON.stringify(serializedNodes)

    const id = getGlobalId(globalParentId, query)
    const name = globalCustomBlocks.find((block) => block.id === id).name
    // lo modifico sul DB e nello store
    updateGlobalCustomBlock(id, name, json_content)
      .then((data) => {
        console.log(data)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const isAdvancedSettingsAllowed = () => {
    if (!selected) {
      return false
    }

    if (selected === ROOT_NODE) {
      return false
    }

    if (isDisabled(selected, query)) {
      return false
    }

    const parent = query.node(selected).get().data.parent
    const parentNode = query.node(parent).get()
    const ancestors = getAncestors(selected, query)
    const ddb = ancestors.find((nodeId) => {
      return query.node(nodeId).get().data.name === 'DynamicDataBlock'
    })
    if (ddb) {
      return false
    }

    return true
  }

  return (
    <>
      {isAdvancedSettingsAllowed() ? (
        <>
          <ToolbarSection title="Create custom block">
            <CreateCustomBlock selected={selected} />
          </ToolbarSection>
          {/* {!isGlobal ?
            <ToolbarSection title="Create global custom block">
                <CreateGlobalCustomBlock selected={selected} />
            </ToolbarSection>
        :
            <ToolbarSection title="Global custom block">
                <button onClick={() => onSaveGlobalCustomBlock(selected)}>Save changes</button>
            </ToolbarSection>
        } */}
        </>
      ) : (
        <div>
          <p>Click on a component to start editing.</p>
        </div>
      )}
    </>
  )
}
